import ReactDOM from 'react-dom/client'
import '@fontsource-variable/inter'
import App from './App'
import './index.css'
import { loadRuntimeConfig } from './services/runtimeConfig'
import { initTheme } from './lib/theme'

// Apply the persisted theme before first paint to avoid a flash.
initTheme()

// Load runtime config (Cloudflare Pages env vars via /runtime-config) before
// rendering so the deployment can be reconfigured without a rebuild. On hosts
// without that endpoint the fetch fails and the services fall back to the
// build-time import.meta.env values.
async function bootstrap() {
  try {
    await loadRuntimeConfig()
  } catch {
    // No /runtime-config available — fall back to import.meta.env.
  }
  ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
}

bootstrap()
